import React, { Component } from 'react';
import '../CSS/newRecord.css';
import GenericNavbar from './Navbar/GenericNavbar';

import SimpleStorageContract from "../contracts/SimpleStorage.json";

import KaspTokens from "../contracts/KaspTokens.json";
import KaspTokenSale from "../contracts/KaspTokenSale.json";


import getWeb3 from "../utils/getWeb3";

import Sidemenu from './Navbar/Sidemenu';

class NewCoin extends Component{
    constructor(props){
        super(props)
        this.state = {
            name: '',
            email:'',
            phone: '',
            query:'',
            address:'',
            userId:'',
            KaspTokenSaleInstance:'',
            balance:'',
            symbol:'',
            tokenSold:'',
            available:'',
            tokenprice:'',
            user:'',
            amt:''
        }
        this.subMitQuery = this.subMitQuery.bind(this)
        this.byeCoin = this.byeCoin.bind(this)
    }

    byeCoin(event){
        event.preventDefault()
        var coin = this.state.amt 
        console.log(coin);
        fetch(`
        http://52.60.64.107/api/orginatorx-new/new-coin.php?coin=${coin}&user_id=${this.state.user.id}&address=${this.state.address[0]}`)
        .then(response => response.json()) // user_id,address,coin
            .then(data => {
                    this.setState({coin: ''});
                    this.setState({amt: ''});

            }); 

        let con = Math.floor( coin );
          con = Number( con );
        console.log(con);
        let res = this.state.KaspTokenSaleInstance.methods.buyTokens(con).send({
           from: this.state.address[0],
           value: con * this.state.tokenprice
         });
    }
  

    async loadBlockChain() {
        console.log('loadBlockChain');
        const web3 = await getWeb3();
        console.log(web3)
        //const accounts = web3.eth.getAccounts().then();
        const accounts = await web3.eth.getAccounts();
        console.log(accounts);
        this.setState({address: accounts});
        
        const networkId = await web3.eth.net.getId();
        const KaspTokensInstance = new web3.eth.Contract(
          KaspTokens.abi,
          KaspTokens.networks[networkId] &&
            KaspTokens.networks[networkId].address
        );
        console.log(KaspTokensInstance);
    
        const KaspTokenSaleInstance = new web3.eth.Contract(
          KaspTokenSale.abi,
          KaspTokenSale.networks[networkId] &&
            KaspTokenSale.networks[networkId].address
        );
        this.setState({KaspTokenSaleInstance: KaspTokenSaleInstance});
    
        const balance = await KaspTokensInstance.methods
              .balanceOf(accounts[0])
              .call();
              console.log(balance);
              this.setState({balance: balance});
    
            const symbol = await KaspTokensInstance.methods.symbol().call(); // symbol
            this.setState({symbol: symbol});
    
            const to_name = await KaspTokensInstance.methods.name().call();
    
            const tokenSold = await KaspTokenSaleInstance.methods
              .tokenSold()
              .call();
              this.setState({tokenSold: tokenSold});
            const available = await KaspTokenSaleInstance.methods
              .tokensLeft()
              .call();
              
            const sum = ~~available + ~~tokenSold;
            this.setState({available: sum});
            const tokenprice = await KaspTokenSaleInstance.methods
              .tokenprice()
              .call();
              console.log(tokenSold);
              this.setState({tokenprice: tokenprice});
    
    
      }
    subMitQuery(){
        console.log(this.state);
        fetch(`
    http://coin.shekel.world/api/coin/query.php?name=${this.state.name}&email=${this.state.email}
    &phone=${this.state.phone}&query=${this.state.query}`)
            .then(response => response.json())
            .then(data => {
                //this.getAllRolle();
                this.setState({name: '' })
                this.setState({email: '' })
                this.setState({phone: '' })
                this.setState({query: '' })
                this.setState({amt: '' })
            });
    }

    componentDidMount(){
        this.loadBlockChain();
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
			this.setState({user:user});
		}
    }

  

    render()
    {
        return(
            <div className = "">
                <GenericNavbar/>
                {this.state.address &&
                <p className='wal-address'>{this.state.address[0] } </p>
                }
                <div className="container-fluid bg-black">
                <div className="row">
                    <Sidemenu />
                   
                    <div className="col s10">
                        <div className="card reportCard">
                            <div className="card-title cardTitle2">
                                <h4 className = "cardTitle">Buy Coin</h4>
                            </div>
                            <div className="card-content s8">
                                <form onSubmit={this.onSubmit}>
                                <input type="text" class="form-control" placeholder="" aria-label="" 
                                aria-describedby="basic-addon1"
                                value={this.state.amt}
                                onChange={(e)=>{this.setState({amt: e.target.value}) } }
                                 />
                                <div class="input-group-prepend">
                                    
                                </div>

                                    <div className="form-submit center">
                                    <button class="dropbtn1" type="button"
                                    style={{marginTop:"10px"}}
                                    onClick={this.byeCoin}
                                    >Buy</button>
                                        
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default NewCoin;
